import { FontWeights, IButtonStyles, ICheckboxStyles, ILinkStyles, IStackStyles, mergeStyles } from "office-ui-fabric-react";

export const searchModeButtonWidth = 140;
export const searchModeSearchBoxWidth = 280;
export const searchModeControlsWidth = searchModeButtonWidth + searchModeSearchBoxWidth;

const searchModeTabRoot = {
    minWidth: 120,
    border: "1px solid #d0d7de",
    backgroundColor: "white",
};

export const searchModeButtonS: Partial<IButtonStyles> = {
    root: {
        minWidth: searchModeButtonWidth,
        width: searchModeButtonWidth,
        maxWidth: searchModeButtonWidth,
        height: 32,
        border: "1px solid rgba(255, 255, 255, 0.45)",
        backgroundColor: "rgba(255, 255, 255, 0.14)",
        color: "white",
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
    },
    rootHovered: {
        backgroundColor: "rgba(255, 255, 255, 0.24)",
        color: "white",
    },
    rootPressed: {
        backgroundColor: "rgba(255, 255, 255, 0.24)",
        color: "white",
    },
    label: {
        fontWeight: 500,
    },
    menuIcon: {
        color: "white",
    },
};

export const inactiveSearchModeTabS: Partial<IButtonStyles> = {
    root: searchModeTabRoot,
};

export const activeSearchModeTabS: Partial<IButtonStyles> = {
    root: {
        ...searchModeTabRoot,
        border: "1px solid #0f6cbd",
        backgroundColor: "#deecf9",
    },
};

export const searchModeCalloutContentS: IStackStyles = {
    root: {
        width: "100%",
        padding: 16,
        boxSizing: "border-box",
        overflow: "hidden",
    },
};

export const searchModeFieldsS: IStackStyles = {
    root: {
        overflow: "hidden",
    },
};

export const searchModeFieldsColumnsS: IStackStyles = {
    root: {
        width: "100%",
        overflow: "hidden",
    },
};

export const searchModeFieldColumnS: IStackStyles = {
    root: {
        width: "calc(50% - 8px)",
        minWidth: 0,
    },
};

export const searchModeCheckboxS: Partial<ICheckboxStyles> = {
    root: {
        width: "100%",
        overflow: "hidden",
    },
    label: {
        whiteSpace: "normal",
        wordBreak: "break-word",
    },
};

export const searchModeSectionTitle = mergeStyles({
    fontWeight: FontWeights.semibold,
});

export const searchModeActionsS: Partial<ILinkStyles> = {
    root: {
        fontWeight: FontWeights.semibold,
    },
};